
import React, { useEffect, useState } from "react";
import { Menu, Button, MenuProps, Input, Modal, Tabs, Select, message, notification, Row, Col, Form, Spin, Checkbox, Switch } from 'antd';
import { useAppContext } from "../../../context/appContext";
import exchanges from "../../common/exchanges";
import { CloseOutlined } from '@ant-design/icons';
const { TextArea } = Input;
const CreateMarketConfigModal = ({ displayCreateMarketConfig, setDisplayCreateMarketConfig, onMarketConfigCreate, selectedMarketConfig = null, setSelectedMarketConfig }) => {

    const [marketConfig, setMarketConfig] = useState({
        first_asset: null,
        second_asset: null,
        price: null,
        option: 'static',
        selected_exchange: null,
        is_sandbox: false,

    })

    const [option, setOption] = useState('static');

    const goBack = () => {
        setSelectedMarketConfig();
        setDisplayCreateMarketConfig(false)
    }

    useEffect(() => {
        if (selectedMarketConfig) {
            setMarketConfig({
                id: selectedMarketConfig.id,
                first_asset: selectedMarketConfig.first_asset,
                second_asset: selectedMarketConfig.second_asset,
                price: selectedMarketConfig.price || 0,
                option: selectedMarketConfig?.option || 'static',
                selected_exchange: selectedMarketConfig?.selected_exchange,
                custom_api_url: selectedMarketConfig?.custom_api_url,
                custom_websocket_url: selectedMarketConfig?.custom_websocket_url,
                is_sandbox: selectedMarketConfig?.is_sandbox,
            })
        }
    }, [selectedMarketConfig])



    return (
        <Modal
            maskClosable={false}
            closeIcon={<CloseOutlined style={{ color: "white" }} />}
            bodyStyle={{
                backgroundColor: 'black',
                border: "1px solid grey"
            }}
            visible={displayCreateMarketConfig} footer={null} onCancel={() => { setSelectedMarketConfig(); setDisplayCreateMarketConfig(false); }}>
            <div style={{ fontWeight: "600", color: "white" }}>{selectedMarketConfig ? "Update" : "Create"} Market Config </div>
            <div style={{ color: "white", margin: "30px 0" }}>
                <div style={{ display: "flex", flexDirection: "row", gap: 15 }}>
                    <span>
                        <label>Base Asset</label>
                        <Input value={marketConfig.first_asset} onChange={(e) => { setMarketConfig({ ...marketConfig, first_asset: e.target.value }) }} style={{ marginTop: 10 }} placeholder="Select market" /></span>
                    <span>
                        <label>Quote Asset</label>
                        <Input value={marketConfig.second_asset} onChange={(e) => { setMarketConfig({ ...marketConfig, second_asset: e.target.value }) }} style={{ marginTop: 10 }} placeholder="Select market" /></span>
                </div>
            </div>

            <div style={{ color: "white", margin: "30px 0" }}>
                <label>Price Selection</label>
                <div style={{ marginTop: 10 }}>
                    <span style={{ marginRight: 5 }}>Static</span><Switch checked={marketConfig?.option === 'static' ? false : true} onChange={(checked) => {
                        if (checked) {
                            setMarketConfig({ ...marketConfig, option: 'dynamic' })
                        } else {

                            setMarketConfig({ ...marketConfig, option: 'static' })
                        }
                    }} /><span style={{ marginLeft: 5 }}>Dynamic</span>
                </div>
            </div>

            <div style={{ color: "white", margin: "30px 0" }}>
                <label>Price</label>
                {(marketConfig.option === 'static' || !marketConfig.option) && <Input value={marketConfig.price} onChange={(e) => { setMarketConfig({ ...marketConfig, price: e.target.value }) }} style={{ marginTop: 10 }} placeholder="Enter price" />}


                {marketConfig.option === 'dynamic' &&
                    <div style={{ marginTop: 5 }}>
                        <Select
                            showSearch
                            style={{ width: 250 }}
                            placeholder="Search and select an exchange"
                            optionFilterProp="children"
                            value={marketConfig?.selected_exchange}
                            onChange={(value) => {
                                setMarketConfig({ ...marketConfig, selected_exchange: value, ...(value === 'hollaex' && { custom_api_url: "https://api.hollaex.com", custom_websocket_url: "wss://api.hollaex.com/stream" }) })
                            }}
                            filterOption={(input, option) =>
                                option.children.toLowerCase().includes(input.toLowerCase())
                            }
                        >
                            {exchanges.filter(exchange => exchange.value != 'Custom Script').map((exchange) => (
                                <Option key={exchange.value} value={exchange.value}>
                                    {exchange.label}
                                </Option>
                            ))}
                        </Select>

                    </div>
                }

                {marketConfig?.selected_exchange === 'hollaex' && <>
                    {<div style={{ color: "white", margin: "30px 0" }}>
                        <label>Custom API Url (Optional)</label>
                        <Input value={marketConfig.custom_api_url} onChange={(e) => { setMarketConfig({ ...marketConfig, custom_api_url: e.target.value }) }} style={{ marginTop: 10 }} placeholder="Input Custom Url" />
                    </div>}
                    {<div style={{ color: "white", margin: "30px 0" }}>
                        <label>Custom Websocket Url (Optional)</label>
                        <Input value={marketConfig.custom_websocket_url} onChange={(e) => { setMarketConfig({ ...marketConfig, custom_websocket_url: e.target.value }) }} style={{ marginTop: 10 }} placeholder="Input Custom Url" />
                    </div>}


                    <Checkbox checked={marketConfig?.is_sandbox} style={{ color: "white" }} onChange={(e) => {
                        setMarketConfig({ ...marketConfig, is_sandbox: e.target.checked })
                    }}>Sandbox mode </Checkbox>
                </>}



            </div>

            <div style={{ display: "flex", flexDirection: "row", gap: 15, justifyContent: "space-between" }}>
                <Button onClick={() => { goBack() }} style={{ backgroundColor: "#161616", color: "white", flex: 1, height: 50 }} type="default">BACK</Button>
                <Button onClick={() => {
                    if (!marketConfig.first_asset || !marketConfig.second_asset) {
                        message.error("Please enter values for both assets");
                        return;
                    }
                    if (marketConfig.option === 'static' && isNaN(marketConfig.price)) {
                        message.error("Please enter numerical value for price");
                        return;
                    }
                    onMarketConfigCreate(marketConfig, selectedMarketConfig ? 'update' : 'create')

                }} style={{ backgroundColor: "#161616", color: "white", flex: 1, height: 50 }} type="default">OK</Button>
            </div>
        </Modal >
    );
};

export default CreateMarketConfigModal;